import { entityRegistry } from "../common/entities/utilts/columnUtils"

export const createEntities = () => {
    entityRegistry.register('epcr', () => import('./epcrFields'));
    entityRegistry.register('epcrTreatmentMedication', () => import('./epcrTreatmentMedicationFields'));
    entityRegistry.register('epcrTreatmentMedicationDef', () => import('./epcrTreatmentMedicationDefFields'));
}
